import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import QRCode from 'qrcode.react';
import MainContainer from '../../../common/component/MainContainer';
import FormContainer from '../../../common/component/FormContainer';
import Nav from '../../../common/component/Nav/Nav';
import LoadingSpinner from '../../../../engage/components/LoadingSpinner';
import { CustomButton } from '../../../../engage/components/Button/Button';
import styles from '../otp-page.module.scss';
import { useLocation, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const SetupOTP = () => {
  const location = useLocation();
  const history = useHistory();

  const { t } = useTranslation();

  const [user, setUser] = useState(null);
  const [response, setResponse] = useState(null);
  const [authCognitoUser, setAuthCognitoUser] = useState(null);
  const [qRString, setQRString] = useState('');

  const routeState = location.state;
  const userDetails = JSON.parse(localStorage.getItem('userDetails'));

  useEffect(() => {
    if (routeState !== undefined) {
      const routeStateObj = JSON.parse(routeState);
      setUser(routeStateObj.user);
      setResponse(routeStateObj.response);
    }
    if (userDetails !== null) {
      history.push({
        pathname: '/eg/dashboard',
      });
    }
    if (!routeState) {
      history.push({
        pathname: '/login',
      });
    }
    getCognitoAuthUser();
  }, []);

  useEffect(() => {
    if (authCognitoUser !== null) {
      setupTOTP();
    }
  }, [authCognitoUser]);

  const getCognitoAuthUser = async () => {
    try {
      const userResponse = await Auth.currentAuthenticatedUser({ bypassCache: false });
      console.log('userRes', userResponse);
      setAuthCognitoUser(userResponse);
    } catch (error) {
      history.push({
        pathname: '/login',
      });
      setAuthCognitoUser(null);
    }
  };

  const setupTOTP = async () => {
    try {
      const setupOTPResponse = await Auth.setupTOTP(authCognitoUser); //CODE
      const issuer = 'Vormats'; // the website name in authenticator app.
      const QRstring =
        'otpauth://totp/Vormats:' + authCognitoUser.attributes.email + '?secret=' + setupOTPResponse + '&issuer=' + issuer;
      setQRString(QRstring);
    } catch (error) {
      setQRString('');
    }
  };

  const onNextClick = () => {
    history.push({
      pathname: '/OTP/verify',
      state: JSON.stringify({ user: user, response: response }),
    });
  };

  return (
    <>
      <Nav />
      <MainContainer className="content-padding play-bg">
        <div className="grid-container">
          <div className="prefix-25 grid-50 tablet-prefix-20 tablet-grid-60 mobile-grid-100">
            <FormContainer title="Scan QR-code" className="text-center">
              <div className="flex-center">
                <div className="auth-card" style={{ minWidth: '560px', maxWidth: '640px' }}>
                  <p className={styles.messageText}>{t('mfa.instructions')}</p>
                  <div className="qr-container">
                    {qRString !== '' ? <QRCode value={qRString} fgColor="#7C43AA" /> : <LoadingSpinner />}
                  </div>
                  <CustomButton
                    variant="primary"
                    label={t('general.continue')}
                    onClick={onNextClick}
                    loading={false}
                    className={styles.submitButton}
                  />
                </div>
              </div>
            </FormContainer>
          </div>
        </div>
      </MainContainer>
    </>
  );
};

export default SetupOTP;
